function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M34.5 29.02C46.22 26.83 48 17.06 48 6.6a1.8 1.8 0 00-1.8-1.8h-7.8V1.2A1.2 1.2 0 0037.2 0H10.8a1.2 1.2 0 00-1.2 1.2v3.6H1.8A1.8 1.8 0 000 6.6c0 10.46 1.78 20.23 13.5 22.42a14.4 14.4 0 006.9 4.1v7.68h-6a1.2 1.2 0 00-1.2 1.2v4.8a1.2 1.2 0 001.2 1.2h19.2a1.2 1.2 0 001.2-1.2V42a1.2 1.2 0 00-1.2-1.2h-6v-7.68a14.4 14.4 0 006.9-4.1zm3.44-10.18V8H44c-.18 7.95-1.72 13.47-7 16 .63-1.65.95-3.4.94-5.16zM10.05 8H4c.2 7.96 1.74 13.48 7 16a14.32 14.32 0 01-.97-5.15V8z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23.2 24.7v-1.4a5.28 5.28 0 01-3.65-2.3 1.3 1.3 0 01.44-1.79 1.31 1.31 0 011.8.44c.36.59 1.32 1.17 2.7 1.16 1.75 0 2.9-.96 2.9-1.74 0-.34-.16-.68-.63-1.01-.5-.36-1.3-.65-2.37-.73a7.47 7.47 0 01-3.6-1.2c-1-.7-1.79-1.78-1.79-3.15a4 4 0 011.77-3.2 6.1 6.1 0 012.42-1.02v.01V7.3c0-.72.6-1.3 1.31-1.3.73 0 1.31.58 1.31 1.3v1.46c1.23.23 2.34.8 3.12 1.63a1.3 1.3 0 01-.07 1.84 1.31 1.31 0 01-1.85-.07 3.49 3.49 0 00-2.5-.92c-1.74 0-2.9.96-2.9 1.74 0 .3.16.66.67 1.01.53.37 1.34.66 2.33.74 1.39.11 2.68.5 3.67 1.2A3.82 3.82 0 0130 19.07c0 1.36-.76 2.48-1.77 3.2a6.08 6.08 0 01-2.42 1.03v1.4a1.3 1.3 0 01-2.62 0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50.53",
  x2: "16.07",
  y1: "14.91",
  y2: "-17.23",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5DD4E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".32",
  stopColor: "#EAF639"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F8E71C"
})))));